import { Box, makeStyles, Typography } from "@material-ui/core";
import { FC } from "react";
import { GenericObject } from "../../types/generic.types";

const useStyles = makeStyles(() => ({
  flexItems: {
    display: "flex",
    alignItems: "center",
  },
  relativeItems: {
    position: "relative",
    zIndex: 2,
  },
  cancellationStyle: {
    backgroundColor: "#74BD76",
    fontSize: 12,
    color: "#fff",
    width: 45,
    height: 45,
    borderRadius: "50%",
    justifyContent: "center",
  },
  horizontalLine: {
    width: "100%",
    height: "3px",
    backgroundColor: "#ccc",
    position: "absolute",
    left: "0",
    top: "50%",
    zIndex: 1,
  },
  chargeStyle: {
    left: 35,
    top: 15,
  },
}));

const StepperItem: FC<{ step: GenericObject }> = ({ step }) => {
  const classes = useStyles();

  return (
    <Box mb={3} width={150} className={`${classes.flexItems} ${classes.relativeItems}`}>
      <span className={`${classes.flexItems} ${classes.relativeItems} ${classes.cancellationStyle}`}>
        {step.cancelTime} <span>Hr</span>
      </span>
      <Typography
        className={`${classes.flexItems} ${classes.relativeItems} ${classes.chargeStyle}`}
        color="textSecondary"
        variant="body2"
      >
        {step.charge}%
      </Typography>
      <Box className={classes.horizontalLine}></Box>
    </Box>
  );
};

export default StepperItem;
